import type { KnowledgeDocumentSummary } from "../types";

import { Badge } from "@/components/ui/v2/badge";

type SyncStatusBadgeProps = {
  status: KnowledgeDocumentSummary["syncStatus"];
};

const statusConfig = {
  synced: { label: "Synced", variant: "success" as const },
  pending: { label: "Pending", variant: "warning" as const },
  new: { label: "New", variant: "neutral" as const },
};

export function SyncStatusBadge({ status }: SyncStatusBadgeProps) {
  const config = statusConfig[status];
  return (
    <Badge variant={config.variant} size="medium">
      {config.label}
    </Badge>
  );
}
